var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['eyecatcher', { [`eyecatcher-${_vm.variant}`]: _vm.variant, [`eyecatcher-${_vm.size}`]: _vm.size }]},[_c('svg',{ref:"svg"},[_c('text',{ref:"text",style:({ fontSize: _vm.fontSize+'px'}),attrs:{"x":"50%","y":"50%","text-anchor":"middle","dominant-baseline":"middle","alignment-baseline":"middle"}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }